import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import "./BookNow.css";
import Loading from "../loading/Loading";

import { submitForm } from "../../services/formService";

const BookNow = () => {
  const { state } = useLocation();
  const { cart, totalPrice } = state || {};

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { clearCart } = useCart();

  const [showPopup, setShowPopup] = useState(false);

  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    startDate: "",
    endDate: "",
    address: "",
    guestCount: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  /*
   * --------------------------------------------------
   * WEB3FORMS
   * --------------------------------------------------
   */
  const sendBookingEmail = async (bookingData) => {
    const accessKey = "9c261127-53cb-4949-9727-30cac22a73eb";

    if (!accessKey) {
      console.error(
        "VITE_WEB3FORMS_ACCESS_KEY is missing from the environment variables.",
      );

      throw new Error("Web3Forms access key is missing.");
    }

    const cartDetails = cart
      .map(
        (item) =>
          `${item.name} | Qty: ${item.quantity} | ₱${(
            Number(item.price) * Number(item.quantity)
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
          })}`,
      )
      .join("\n");

    const formDataToSend = new FormData();

    formDataToSend.append("access_key", accessKey);

    formDataToSend.append("subject", `New Tour Booking - ${bookingData.name}`);

    formDataToSend.append("from_name", "Twin Travel Coron Website");

    formDataToSend.append("replyto", bookingData.email);

    formDataToSend.append("name", bookingData.name);

    formDataToSend.append("email", bookingData.email);

    formDataToSend.append("contact", bookingData.contactNumber);

    formDataToSend.append("start_date", bookingData.startDate);

    formDataToSend.append("end_date", bookingData.endDate);

    formDataToSend.append("address", bookingData.address);

    formDataToSend.append("guest_count", bookingData.guestCount);

    formDataToSend.append(
      "additional_message",
      bookingData.message || "No additional message.",
    );

    formDataToSend.append("tour_booking", cartDetails);

    formDataToSend.append(
      "total_price",
      `₱${Number(bookingData.totalPrice).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      })}`,
    );

    formDataToSend.append(
      "downpayment",
      `₱${(Number(bookingData.totalPrice) * 0.5).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      })}`,
    );

    formDataToSend.append(
      "upon_arrival",
      `₱${(Number(bookingData.totalPrice) * 0.5).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      })}`,
    );

    formDataToSend.append(
      "message",
      `
NEW TOUR BOOKING

Customer Information
--------------------
Name: ${bookingData.name}
Email: ${bookingData.email}
Contact: ${bookingData.contactNumber}
Address: ${bookingData.address}

Booking Information
-------------------
Start Date: ${bookingData.startDate}
End Date: ${bookingData.endDate}
Guests: ${bookingData.guestCount}

Tours / Packages
----------------
${cartDetails}

Payment
-------
Total Price: ₱${Number(bookingData.totalPrice).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      })}

Downpayment (50%): ₱${(Number(bookingData.totalPrice) * 0.5).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        },
      )}

Upon Arrival (50%): ₱${(Number(bookingData.totalPrice) * 0.5).toLocaleString(
        "en-US",
        {
          minimumFractionDigits: 2,
        },
      )}

Additional Message
------------------
${bookingData.message || "None"}
      `.trim(),
    );

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formDataToSend,
    });

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message || "Failed to send booking email.");
    }

    return result;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   const bookingData = {
  //     name: formData.name,
  //     email: formData.email,
  //     contactNumber: formData.contact,
  //     startDate: formData.startDate,
  //     endDate: formData.endDate,
  //     address: formData.address,
  //     guestCount: formData.guestCount,
  //     message: formData.message,

  //     cart: cart.map((item) => ({
  //       name: item.name,
  //       quantity: item.quantity,
  //       price: item.price,
  //       imgUrl: item.imgArray[0],
  //       typeOfTour: item.typeOfTour,
  //     })),

  //     totalPrice: totalPrice,
  //   };

  //   try {
  //     /*
  //      * 1. Submit to your existing backend/database
  //      */
  //     const response = await submitForm(bookingData);

  //     console.log("Submitting Form Data:", bookingData);

  //     if (response.message === "Booking submitted successfully") {
  //       /*
  //        * 2. Send email notification through Web3Forms
  //        */
  //       try {
  //         await sendBookingEmail(bookingData);

  //         console.log("Web3Forms booking email sent successfully.");
  //       } catch (emailError) {
  //         /*
  //          * Don't reject the booking if only the email failed.
  //          * The booking has already been successfully submitted.
  //          */
  //         console.error(
  //           "Booking was submitted, but Web3Forms email failed:",
  //           emailError,
  //         );
  //       }

  //       setShowPopup(true);
  //       clearCart();
  //     } else {
  //       alert("Error submitting form. Please try again.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Something went wrong!");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const bookingData = {
      name: formData.name,
      email: formData.email,
      contactNumber: formData.contact,
      startDate: formData.startDate,
      endDate: formData.endDate,
      address: formData.address,
      guestCount: formData.guestCount,
      message: formData.message,

      cart: cart.map((item) => ({
        name: item.name,
        quantity: item.quantity,
        price: item.price,
        imgUrl: item.imgArray[0],
        typeOfTour: item.typeOfTour,
      })),

      totalPrice: totalPrice,
    };

    try {
      await sendBookingEmail(bookingData);

      console.log(
        "Booking submitted successfully through Web3Forms:",
        bookingData,
      );

      setShowPopup(true);
      clearCart();
    } catch (error) {
      console.error("Error submitting booking:", error);

      alert(
        error.message ||
          "Something went wrong while submitting your booking. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleProceedToPayment = () => {
    setIsLoading(true);

    setTimeout(() => {
      navigate("/tours/book-now/payment");
      window.scrollTo(0, 0);
    }, 1500);
  };

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");

    return `${hours}:${minutes}:${secs}`;
  };

  return (
    <>
      {isLoading && <Loading />}

      <div className="book-now-container">
        <h2>Complete Your Booking</h2>

        <form className="booking-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            required
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
            onChange={handleChange}
          />

          <input
            type="tel"
            name="contact"
            placeholder="Contact Number"
            required
            onChange={handleChange}
          />

          <label htmlFor="startDate" className="label-style">
            Start Date
          </label>

          <input
            id="startDate"
            type="date"
            name="startDate"
            min={today}
            required
            onChange={handleChange}
          />

          <label htmlFor="endDate" className="label-style">
            End Date
          </label>

          <input
            id="endDate"
            type="date"
            name="endDate"
            min={formData.startDate || today}
            required
            onChange={handleChange}
          />

          <input
            type="text"
            name="address"
            placeholder="Address"
            required
            onChange={handleChange}
          />

          <input
            type="number"
            name="guestCount"
            placeholder="Total Guest Count"
            min="1"
            required
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Additional Message / Hotel Name / Tour details per day"
            rows="4"
            value={formData.message}
            onChange={handleChange}
          />

          <h4>Booking Summary</h4>

          <ul className="booking-summary">
            {cart.map((item) => (
              <li key={item.id}>
                <img
                  src={item.imgArray[0]}
                  alt={item.name}
                  className="cart-item-img"
                  loading="lazy"
                />

                <span>
                  {item.name} (Qty: {item.quantity})
                </span>

                <span>
                  ₱
                  {(Number(item.price) * Number(item.quantity)).toLocaleString(
                    "en-US",
                    {
                      minimumFractionDigits: 2,
                    },
                  )}
                </span>
              </li>
            ))}
          </ul>

          <p className="total-price">
            Total Price: ₱
            {Number(totalPrice).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}
          </p>

          <p className="downpayment">
            Downpayment (50%): ₱
            {(Number(totalPrice) * 0.5).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}
          </p>

          <p className="upon-arrival">
            Upon Arrival (50%): ₱
            {(Number(totalPrice) * 0.5).toLocaleString("en-US", {
              minimumFractionDigits: 2,
            })}
          </p>

          <button type="submit" className="submit-booking">
            Confirm & Pay
          </button>
        </form>

        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <h2>Twin Travel Coron</h2>

              <p className="reference-message">
                Screenshot this for reference.
              </p>

              <p>
                Thanks for booking! We've received your request. Check your
                email for details. We'll contact you once payment is verified.
              </p>

              <p className="paymentCountdown">
                Complete payment within{" "}
                <span id="countdown">{formatTime(timeLeft)}</span> to secure
                your booking.
              </p>

              <h3>Booking Confirmed!</h3>

              <p>
                <strong>Name:</strong> {formData.name}
              </p>

              <p>
                <strong>Email:</strong> {formData.email}
              </p>

              <p>
                <strong>Contact:</strong> {formData.contact}
              </p>

              <p>
                <strong>Start Date:</strong>{" "}
                {new Date(formData.startDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              <p>
                <strong>End Date:</strong>{" "}
                {new Date(formData.endDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              <p>
                <strong>Address:</strong> {formData.address}
              </p>

              <p>
                <strong>Guests:</strong> {formData.guestCount}
              </p>

              <p className="total-price">
                Total: ₱
                {Number(totalPrice).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })}
              </p>

              <p className="downpayment">
                Downpayment (50%): ₱
                {(Number(totalPrice) * 0.5).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })}
              </p>

              <p className="upon-arrival">
                Upon Arrival (50%): ₱
                {(Number(totalPrice) * 0.5).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                })}
              </p>

              <button onClick={handleProceedToPayment} disabled={isLoading}>
                Proceed to Payment
              </button>

              <h4>Booking Summary</h4>

              <ul className="popup-summary">
                {cart.map((item) => (
                  <li key={item.id}>
                    {item.name} (Qty: {item.quantity})
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BookNow;
